import { useEffect } from 'react';

export function useOverlayState({
  selector,
  isOpenCondition,
  activeClass,
}: {
  selector: string;
  isOpenCondition: (element: Element) => boolean;
  activeClass: string;
}) {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    if (elements.length === 0) return;

    const openElements = new Set<Element>();

    const updateBodyClass = () => {
      const mainWrapper = document.querySelector('.main-wrapper');

      if (!mainWrapper) return;

      if (openElements.size > 0) {
        mainWrapper.classList.add(activeClass, 'group');
      } else {
        mainWrapper.classList.remove(activeClass, 'group');
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const target = mutation.target as Element;

          if (isOpenCondition(target)) {
            openElements.add(target);
          } else {
            openElements.delete(target);
          }

          updateBodyClass();
        }
      });
    });

    elements.forEach((element) => {
      if (isOpenCondition(element)) {
        openElements.add(element);
      }

      observer.observe(element, { attributes: true });
    });

    updateBodyClass();

    return () => {
      observer.disconnect();
      openElements.clear();
    };
  }, [selector, isOpenCondition, activeClass]);
}

export function useNavigationOverlay() {
  useOverlayState({
    selector: 'a[data-state]',
    isOpenCondition: (el) => el.getAttribute('data-state') === 'open',
    activeClass: 'navigation-open',
  });
}

export function useSearchOverlay(isDropdownOpen: boolean, showResults: boolean) {
  useOverlayState({
    selector: '#search-dropdown',
    isOpenCondition: () => isDropdownOpen && showResults,
    activeClass: 'search-open',
  });
}
